import { buildApiBase } from '@/api/baseUrl';
import { AUTH_CLUSTER, CLUSTER_HOST, DEV_PROXY_PREFIX, type Cluster, type DeployEnv } from '@/backends';

const DEPLOY_ENV: DeployEnv = import.meta.env.VITE_DEPLOY_ENV === 'prod' ? 'prod' : 'qa';

/**
 * Resolve a cluster's API base URL:
 *   - dev: a same-origin proxy prefix (e.g. `/be-br/v1`)
 *   - build: the absolute host for this deploy env
 */
export function clusterBase(cluster: Cluster): string {
  return buildApiBase(import.meta.env.DEV ? DEV_PROXY_PREFIX[cluster] : CLUSTER_HOST[cluster][DEPLOY_ENV]);
}

/** Single sign-in endpoint (unified auth). Always the EU cluster. */
export const AUTH_BASE_URL = clusterBase(AUTH_CLUSTER);
